<div class="fdx-u-mt--7 fdx-u-mb--5 fdx-u-color--grey--dark-1">
  <h3 class="fdx-c-header fdx-c-header--h3 fdx-u-align--center">Toast</h3>
</div>
<form (submit)="buildToast()" [formGroup]="toastFormGroup" class="fdx-u-mb--5">

  <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small fdx-u-mb--1">
    <div class="fdx-o-grid__item--12">
      <div class="fdx-c-form-group fdx-c-form-group--select fdx-c-form-group--asd">
        <span class="fdx-c-form-group__item">
          <select [formControl]="toastPriorityControl" class="fdx-c-form-group__select" id="toastPriority">
            <option *ngFor="let priority of priorities" [ngValue]="priority">{{priority}}</option>
          </select>
          <span aria-hidden="true" class="fdx-c-form-group__icon">
            <ciam-icon class="fdx-c-icon" aria-hidden="true" key="chevron"></ciam-icon>
          </span>
          <label class="fdx-c-form-group__label " for="toastPriority">Priority</label>
        </span>
      </div>
    </div>
  </div>

  <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small fdx-u-mb--1">
    <div class="fdx-o-grid__item--6">
      <div class="fdx-c-form-group fdx-c-form-group--select fdx-c-form-group--asd">
        <span class="fdx-c-form-group__item">
          <select [formControl]="toastTypeControl" class="fdx-c-form-group__select" id="toastType">
            <option value="text">Text</option>
            <option value="template">Template</option>
          </select>
          <span aria-hidden="true" class="fdx-c-form-group__icon">
            <ciam-icon class="fdx-c-icon" aria-hidden="true" key="chevron"></ciam-icon>
          </span>
          <label class="fdx-c-form-group__label " for="toastPriority">Type</label>
        </span>
      </div>
    </div>


    <ng-container [ngSwitch]="toastTypeControl.value">

      <div *ngSwitchCase="'text'" class="fdx-o-grid__item--6">
        <div [class.fdx-c-form-group--has-value]="toastMessageControl.value"
             class="fdx-c-form-group fdx-c-form-group fdx-c-form-group--float-label">
          <div class="fdx-c-form-group__item">
            <input [formControl]="toastMessageControl" class="fdx-c-form-group__input" id="toastMessage" type="text">
            <label class="fdx-c-form-group__label fdx-c-form-group__label--dark" for="toastMessage">
              Message
            </label>
          </div>
        </div>
      </div>

      <div *ngSwitchCase="'template'"
           class="fdx-o-grid__item--6">
        <div class="fdx-c-form-group fdx-c-form-group--select fdx-c-form-group--asd">
        <span class="fdx-c-form-group__item">
          <select [formControl]="toastTemplate" class="fdx-c-form-group__select" id="toastTemplate">
            <option *ngFor="let tmp of toastTemplateRefs; let i = index" [value]="i">Template: {{i + 1}}</option>
          </select>
          <span aria-hidden="true" class="fdx-c-form-group__icon">
            <ciam-icon class="fdx-c-icon" aria-hidden="true" key="chevron"></ciam-icon>
          </span>
          <label class="fdx-c-form-group__label " for="toastTemplate">Toast Templates</label>
        </span>
        </div>
      </div>
    </ng-container>

  </div>

  <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small fdx-u-mb--10">
    <div class="fdx-o-grid__item--4">
      <div class="fdx-c-form-group fdx-c-form-group fdx-c-form-group--float-label fdx-c-form-group--has-value">
        <div class="fdx-c-form-group__item">
          <input [formControl]="toastTitleControl"
                 class="fdx-c-form-group__input"
                 id="toastTitle"
                 placeholder="OPTIONAL"
                 type="text">
          <label class="fdx-c-form-group__label fdx-c-form-group__label--dark" for="toastTitle">
            Title
          </label>
        </div>
      </div>
    </div>
    <div class="fdx-o-grid__item--4">
      <div class="fdx-c-form-group fdx-c-form-group fdx-c-form-group--float-label fdx-c-form-group--has-value">
        <div class="fdx-c-form-group__item">
          <input [formControl]="toastButtonLabelControl"
                 class="fdx-c-form-group__input"
                 id="toastButtonLabel"
                 placeholder="OPTIONAL"
                 type="text">
          <label class="fdx-c-form-group__label fdx-c-form-group__label--dark" for="toastButtonLabel">
            Button Label
          </label>
        </div>
      </div>
    </div>
    <div class="fdx-o-grid__item--4">
      <div
        class="fdx-c-form-group fdx-c-form-group fdx-c-form-group--float-label fdx-c-form-group--has-value">
        <div class="fdx-c-form-group__item">
          <input [formControl]="toastButtonUrlControl"
                 class="fdx-c-form-group__input"
                 id="toastButtonUrl"
                 placeholder="OPTIONAL"
                 type="url">
          <label class="fdx-c-form-group__label fdx-c-form-group__label--dark" for="toastButtonUrl">
            Button URL
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="fdx-u-align--center">
    <button class="fdx-c-button fdx-c-button--full-width fdx-c-button--primary fdx-c-button--responsive">
      Build Toast
    </button>
  </div>
</form>

<div class="fdx-u-align--center">
  <button (click)="cancelAllPoprs()" class="fdx-c-button fdx-c-button--text">
    Cancel All Poprs
  </button>
</div>

<ng-template #poprTemplate>
  <p class="fdx-u-rotate--180 fdx-u-color--orange orange">Message color orange and rotated 180º</p>
</ng-template>
<ng-template #poprTemplate>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" width="200" height="100" version="1.1">
      <rect cx="30" cy="30" rect width="200" height="100" fill="orange"></rect>
      <circle cx="100" cy="90" r="50" stroke="#5cb85c" stroke-width="6" fill="#4d148c"></circle>
      <text fill="#ffffff" font-size="45" font-family="Verdana" x="50" y="86">SVG</text>
    </svg>
  </div>
</ng-template>
<ng-template #poprTemplate>
  <p>
    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab eligendi error esse eveniet fuga mollitia neque optio quasi ratione sapiente!
  </p>
  <ul>
    <li>Lorem ipsum dolor sit amet, consectetur adipisicing.</li>
    <li>Iusto natus nesciunt quasi tenetur. Accusamus, officiis!
      <ul>
        <li>Lorem ipsum dolor sit amet, consectetur.</li>
      </ul>
    </li>
  </ul>
</ng-template>
